"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tipografia = void 0;
var react_1 = require("react");
var globalMu_1 = __importDefault(require("../../globalMu"));
var GradacaoNeutros_1 = __importDefault(require("../Cores/GradacaoNeutros "));
var Tipografia = function (_a) {
    var label = _a.label, _b = _a.cor, cor = _b === void 0 ? GradacaoNeutros_1.default.PretoMU900 : _b, size = _a.size, _c = _a.sublinhado, sublinhado = _c === void 0 ? false : _c, _d = _a.negrito, negrito = _d === void 0 ? 400 : _d, _e = _a.italico, italico = _e === void 0 ? false : _e, _f = _a.espacamentoLinha, espacamentoLinha = _f === void 0 ? "normal" : _f, _g = _a.overline, overline = _g === void 0 ? false : _g, espacamentoCaractere = _a.espacamentoCaractere, _h = _a.tag, tag = _h === void 0 ? "div" : _h, corOnHover = _a.corOnHover, title = _a.title, style = _a.style, onClick = _a.onClick;
    var _j = (0, react_1.useState)(false), isHovered = _j[0], setIsHovered = _j[1];
    return ((0, react_1.createElement)(tag, {
        onClick: onClick,
        onMouseEnter: corOnHover ? function () { setIsHovered(true); } : undefined,
        onMouseLeave: corOnHover ? function () { setIsHovered(false); } : undefined,
        title: title,
        style: __assign({ color: isHovered && corOnHover ? corOnHover : cor, fontSize: size, fontStyle: (italico ? "italic" : "normal"), textDecorationLine: (sublinhado ? "underline" : "none"), fontWeight: (Number(negrito) > 0 ? negrito : 400), textTransform: (overline ? "uppercase" : "none"), lineHeight: espacamentoLinha, letterSpacing: globalMu_1.default.isNullOrEmptyOrUndefined(espacamentoCaractere) ? "normal" : espacamentoCaractere, width: "fit-content", cursor: onClick ? "pointer" : "inherit" }, style)
    }, label));
};
exports.Tipografia = Tipografia;
